$(document).ready(function() {
	if(!document.querySelector('.GPC0012')) return false;
	
	var $slick = function(){
		var $obj = $('.GPC0012');
		$obj.each(function(){
			var $objNext = $(this).find('.package-next');
			var $objPrev = $(this).find('.package-prev');
			$(this).find('.product-type .items').slick({
				listStyle: true, // WA-GPC0012-01
				autoplay: false,
				infinite: false,
				slidesToShow: 4,
				slidesToScroll: 4,
				dots: false,
				nextArrow:$objNext,
				prevArrow:$objPrev,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					}, {
						breakpoint: 768,
						settings: {
							dots: true,
							arrows: false,
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			});
			runBVStaticPLP($(this));
		});
	};
	$slick();
	
	/* LGEITF-604 Start */
	var priceSync = {
		componentId : $('.GPC0009'),
		bundleComponentId : $('.GPC0012'),
		priceTemplate: null,
		init: function(){
			var _this = this;
			
			_this.priceTemplate = $('#priceSyncGPC0012').clone().html();
			$('#priceSyncGPC0012').remove();
			
			_this.getPrice();
		},
		getPrice: function(){
			var _this = this;
			var originalModelId = _this.componentId.attr('data-product-id');
			var bizType = _this.bundleComponentId.attr('data-biz-type');
			var url = _this.componentId.find('.pdp-summary-area').attr('data-bundle-price-sync-url'),
				param = {
					modelId: originalModelId,
					bizType: bizType
				};
				
			ajax.call(url, param, 'json', function(data){
				if(data.status == 'success' && data.data){
					for(var i=0; i<data.data.length; i++){
						var p = data.data[i],
							priceSyncBundleHtml = _this.priceTemplate;
						
						if (priceSyncBundleHtml) {
							$template = _this.makePriceSyncHtml(p, priceSyncBundleHtml);
							var scop = _this.bundleComponentId.find('.item .products-info[data-model-id='+p.modelId+'-'+i+']');
							scop.find('.purchase-price, .product-price').remove();
							scop.find('.price-area').append($template);
						}
					}
				}
			});
		},
		makePriceSyncHtml : function(p, template){
			if (template) {
				
				var $html = $(template);
				var $price;
				
				if(p.modelStatusCode!='ACTIVE') {
					return false;
				}else if(p.retailerPricingFlag=='Y') {
					$price = $($html.find('.retailerTemplate').clone().html());
					$price.find('.retrailer').text(!!p.retailerPricingText ? p.retailerPricingText : '');
				}else {
					if (!!p.rPromoPrice) {
						$price = $($html.find('.rPromoPriceTemplate').clone().html());
						$price.find('.purchase-price .number').text(!!p.rPromoPriceCent ? changeFormatFullPriceSync(p.rPromoPrice, p.rPromoPriceCent) : changeFormatFullPriceSync(p.rPromoPrice));
						$price.find('.product-price .number').text(!!p.rPromoPriceCent ? changeFormatFullPriceSync(p.rPrice, p.rPriceCent) : changeFormatFullPriceSync(p.rPrice));
						$price.find('.product-price .legal').text(!!p.discountMsg ? p.discountMsg : '');
					} else if (!!p.rPrice) {
						$price = $($html.find('.rPriceTemplate').clone().html());
						$price.find('.purchase-price .number').text(!!p.rPriceCent ? changeFormatFullPriceSync(p.rPrice, p.rPriceCent) : changeFormatFullPriceSync(p.rPrice));
					} else if (!!!p.rPromoPrice && !!!p.rPrice) {
						$price = $($price).html('');
					}
				}
				//LGCOMPL-218 start
				if ( p.obsLowestPriceFlag == 'Y' && !!p.rPromoPrice ) {
					if ( $price.find('.lowest-price-mark').length ) $price.find('.lowest-price-mark').removeClass('d-none');
					if ( $html.find('.lowest-price-box').length ) $html.find('.lowest-price-box').removeClass('d-none'); 
				} else {
					if ( $price.find('.lowest-price-mark').length ) $price.find('.lowest-price-mark').html('');
					if ( $html.find('.lowest-price-box').length ) $html.find('.lowest-price-box').html('');
				}
				//LGCOMPL-218 end

				$html.html($price);
				return $html.html();
			}
		},
	}
	
	priceSync.init();
	/* LGEITF-604 End */
});
